import RfiInstance from './RfiInstance.component';

export default RfiInstance;